import { type AggregationFn } from "@tanstack/react-table";

import { isComparableNumber } from "./aggregationFnUtils";

export const extent: AggregationFn<unknown> = (columnId, leafRows, _immediateChildRows) => {
	let min: number | undefined;
	let max: number | undefined;

	// NOTE: If we ever support nested columns, we might want to `extent` the `immediateChildRows`
	// of this grouping, since they'll have aggregated their own children.
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		if (isComparableNumber(value)) {
			if (min === undefined || min > value) {
				min = value;
			}
			if (max === undefined || max < value) {
				max = value;
			}
		}
	});

	return `[${min}, ${max}]`;
};
